import * as React from 'react';
import {IBundle} from "../../data/BundleData";

import './BundleCard.pcss';
import {observer} from "mobx-react";
import {ButtonAction} from "./ButtonAction";

interface Props {
  bundle:IBundle;
  onClick:(bundle:IBundle)=>void;
  pointsAwarded?:number;
  possiblePoints?:number;
  actionWord?:string;
}

export const BundleCard = observer((props:Props) => {

  function onClick() {
    props.onClick(props.bundle);
  }

  const previewImageStyle = {
    backgroundImage: `url("${props.bundle.photo}")`,
  }

  return(
    <div className={"bundle-card"}>
      <div className={"bc-preview"}>
        <ButtonAction
            buttonActionIsBroken
            aria-label={`${props.actionWord?props.actionWord:'View'} ${props.bundle.fullName}`}
            onClick={onClick}
        >
          <div className={"bc-preview-image"} style={previewImageStyle}></div>
        </ButtonAction>
      </div>
      <div className={"bc-info"}>
        <h2>{props.bundle.fullName}</h2>
        <p>{props.bundle.cardSubTitle}</p>
        {undefined !== props.possiblePoints && props.possiblePoints>0&&<div>
          {props.pointsAwarded===props.possiblePoints?
              <p className={'bci-points-awarded'}><span className={"material-icons"}>check_circle</span> Completed <span className={"bci-points"}>{`(${props.possiblePoints} points)`}</span></p>
              :
              <p className={'bci-points-available'}>{`${props.possiblePoints} points available`}</p>
          }
        </div>}
      </div>
    </div>
  );
});

